import * as types from './types';

/**
 * Initial state for the reducer
 * @type {Local.AppContextState}
 */
export const initialState = {
  selectedPlant: localStorage.getItem(types.SELECTED_PLANT) || '',
  selectedLocation: localStorage.getItem(types.SELECTED_LOCATION) || '',
  selectedResource: localStorage.getItem(types.SELECTED_RESOURCE) || '',
  activeTab: '',
  resourceQueueSelectedId: '',
  selectionListSelectedId: '',
};

/**
 * Reducer function to manage the state
 * @param {Local.AppContextState} state - Current state
 * @param {{type: string, payload: string}} action - Action to execute
 * @returns {Local.AppContextState} New state
 */
export const reducer = (state, action) => {
  switch (action.type) {
    case types.SELECTED_PLANT:
      return {
        ...state,
        selectedPlant: action.payload,
      };
    case types.SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation: action.payload,
      };
    case types.SELECTED_RESOURCE:
      return {
        ...state,
        selectedResource: action.payload,
      };
    case types.ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };
    case types.RESOURCE_QUEUE_SELECTED_ID:
      return {
        ...state,
        resourceQueueSelectedId: action.payload,
      };

    case types.SELECTION_LIST_SELECTED_ID:
      return {
        ...state,
        selectionListSelectedId: action.payload,
      };

    default:
      return state;
  }
};
